export const WIX_MEDIA_BASE_URL = 'https://static.wixstatic.com/';
export const WIX_VIDEO_BASE_URL = 'https://video.wixstatic.com/';
